import { useAuth } from 'lib/auth';
import { useNavigate, useRoutes } from 'react-router-dom';

import { protectedRoutes } from './protected';
import { useEffect } from 'react';
import { GATEKEEPER_URL } from 'config';
import { generateDeepLink, parseDeepLink } from 'react-deep-link';
import Cookies from 'js-cookie';

export const AppRoutes = () => {
  const auth = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    const initialize = async () => {
      console.log(auth.user);

      if (!auth.user) {
        const parsed = parseDeepLink(
          new URLSearchParams(window.location.search)
        );

        if (parsed.state?.token) {
          Cookies.set('token', parsed.state.token);
          console.log('Token set in initializer');

          auth.refetchUser();

          // Redirect logic
          let redirectPath = parsed.state.redirectPath || '';
          const baseUrl = parsed.state.baseUrl;

          if (baseUrl) {
            const inappUrl = baseUrl + redirectPath;
            console.log(`Redirecting to ${inappUrl}`);
            window.location.href = inappUrl;
            return; // prevent falling through to navigate('/app')
          }
        }
      }

      // Fallback navigation
      if (
        window.location.pathname === '/' ||
        window.location.pathname === '' ||
        window.location.search.startsWith('?token=')
      ) {
        navigate('/app', { replace: true });
      }
    };

    initialize();
  }, [auth.user, navigate]);

  let routes = [];
  if (!auth.user) {
    const url = generateDeepLink({
      baseUrl: GATEKEEPER_URL,
      route: '/auth/login',
      state: {
        app: 'finance',
        redirectPath: '/app',
      },
    });

    window.location.href = url;
  } else {
    routes = protectedRoutes;
  }

  const element = useRoutes([...routes]);

  return <>{element}</>;
};
